const tileReducer = (state = {
}, action) => {
  switch (action.type) {
    case 'GET_TILES':
      return {
        ...state,
        tiles: [...state.tiles, ...Object.keys(action.tiles.tiles).map(key => action.tiles.tiles[key])],
        page: action.tiles.page,
        hasNextPage: action.tiles.hasNextPage,
      };
    case 'SET_PAGE':
      return {
        ...state,
        page: action.page,
      };
    case 'SET_SCROLL_POSITION':
      return {
        ...state,
        scrollPosition: action.scrollPosition,
      };
    case 'RESET_TILES':
      return {
        ...state,
        tiles: action.tiles,
        page: action.page,
        scrollPosition: action.scrollPosition,
      };
    case 'TILE_COUNTER_HACK':
      return {
        ...state,
        counterHack: (state.counterHack || 0) + 1,
      };
    default:
      return { ...state };
  }
};
export default tileReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/tileReducer.jsx